import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import D3Heatmap from './D3Heatmap.vue'
import GraphCard from './GraphCard.vue'
import { computed } from 'vue'
import {
  HeatmapResponse,
  HeatmapSettings,
  HeatmapValue
} from '@/api-client/models/utilization/Contracts'
import { useI18n } from 'vue-i18n'
import { CardState } from '../../types'

type Props = {
  data?: HeatmapResponse
  state: CardState
  hasError?: Error
  settings?: HeatmapSettings
  accessKey: keyof HeatmapValue
}

export default /*@__PURE__*/_defineComponent({
  __name: 'GraphHeatmapCard',
  props: {
    data: {},
    state: {},
    hasError: {},
    settings: {},
    accessKey: {}
  },
  setup(__props: any) {

const props = __props

const filterMessage = computed(() => {
  if (!props.data) return t('general__data__data-missing')
  return t('general__text__filter-to-show-data')
})
const { t, locale } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GraphCard, {
    title: _ctx.settings?.title[_unref(locale)],
    state: _ctx.state,
    hasError: _ctx.hasError,
    filterMessage: filterMessage.value,
    additionalInfo: _ctx.settings?.info?.[_unref(locale)]
  }, {
    default: _withCtx(() => [
      _createVNode(D3Heatmap, {
        data: _ctx.data!,
        "x-access-key": _ctx.accessKey,
        "color-min": _ctx.settings?.colorMin ?? '#E6F7FF',
        "color-max": _ctx.settings?.colorMax ?? '#40A9FF'
      }, null, 8, ["data", "x-access-key", "color-min", "color-max"])
    ]),
    _: 1
  }, 8, ["title", "state", "hasError", "filterMessage", "additionalInfo"]))
}
}

})